import { render, staticRenderFns } from "./album.vue?vue&type=template&id=b387592c&scoped=true"
import script from "./album.vue?vue&type=script&lang=ts"
export * from "./album.vue?vue&type=script&lang=ts"
import style0 from "./album.vue?vue&type=style&index=0&id=b387592c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b387592c",
  null
  
)

export default component.exports